class ArtistsList extends HTMLElement {
  links = [];
  artists = [];
  fullArtists = [];
  loaded = false;
  loading = false;
  artistsList = null;
  searchDropdown = null;
  searchInput = null;
  searchResults = null;
  searchOpen = false;
  isMobile = null;
  constructor() {
    super();
    this.onLetterMouseOver = this.onLetterMouseOver.bind(this);
    this.showLetter = this.showLetter.bind(this);
    this.showArtistsList = this.showArtistsList.bind(this);
    this.hideArtistsList = this.hideArtistsList.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onSearchTriggerHover = this.onSearchTriggerHover.bind(this);
    this.onSearchInput = this.onSearchInput.bind(this);
    this.hideSearchDropdown = this.hideSearchDropdown.bind(this);
  }
  connectedCallback() {
    this.links = this.querySelectorAll('a');
    this.artistsList = this.querySelector('[data-artists-list]');
    this.searchDropdown = this.querySelector('[data-artists-search-dropdown]');
    this.searchInput = this.querySelector('[data-artists-search-input]');
    this.searchResults = this.querySelector('[data-artists-search-results]');
    const searchTrigger = this.querySelector('[data-artists-search-trigger]');

    window.addEventListener('resize', this.onResize);
    this.addEventListener('mouseleave', this.hideArtistsList);

    const artists = this.querySelector('#top-bar-artists');
    if (artists) {
      try {
        this.artists = JSON.parse(artists.innerHTML);
      } catch (error) {
        console.error(error);
      }
    }

    const fullArtists = this.querySelector('#full-artists-list');
    if (fullArtists) {
      try {
        this.fullArtists = JSON.parse(fullArtists.innerHTML);
      } catch (error) {
        console.error(error);
      }
    }

    if (searchTrigger) {
      searchTrigger.addEventListener('mouseover', this.onSearchTriggerHover);
      searchTrigger.addEventListener('click', this.onSearchTriggerHover);
    }

    if (this.searchInput) {
      this.searchInput.addEventListener('input', this.onSearchInput);
    }

    this.onResize();
  }
  onResize() {
    if (window.innerWidth <= 989) {
      if (this.isMobile !== true) {
        this.isMobile = true;
        this.removeEventListener('mouseleave', this.hideArtistsList);
        if (this.links.length > 0) {
          [...this.links].map((link) => {
            link.removeEventListener('mouseover', this.onLetterMouseOver);
            link.removeEventListener('click', this.onLetterClick);
            link.addEventListener('click', this.onLetterMouseOver);
          });
        }
      }
    } else {
      if (this.isMobile !== false) {
        this.isMobile = false;
        this.addEventListener('mouseleave', this.hideArtistsList);
        if (this.links.length > 0) {
          [...this.links].map((link) => {
            link.addEventListener('mouseover', this.onLetterMouseOver);
            link.removeEventListener('click', this.onLetterMouseOver);
            link.addEventListener('click', this.onLetterClick);
          });
        }
      }
    }
  }
  onSearchTriggerHover(e) {
    // Hide letter dropdown if open
    if (this.artistsList) {
      this.artistsList.setAttribute('aria-expanded', 'false');
    }
    // Show search dropdown
    this.searchOpen = true;
    if (this.searchDropdown) {
      this.searchDropdown.setAttribute('aria-expanded', 'true');
      const currentValue = this.searchInput?.value?.trim() || '';
      if (currentValue.length >= 2) {
        // Re-run search with existing value
        const filtered = this.fullArtists.filter((artist) =>
          artist.name.toLowerCase().includes(currentValue.toLowerCase())
        );
        this.renderSearchResults(filtered);
      } else if (this.searchResults) {
        this.searchResults.innerHTML = '<li class="no-results">Type at least 2 characters to search...</li>';
      }
      if (this.searchInput) {
        setTimeout(() => this.searchInput.focus(), 100);
      }
    }
  }
  onSearchInput(e) {
    const query = e.target.value.toLowerCase().trim();
    if (query.length < 2) {
      if (this.searchResults) {
        this.searchResults.innerHTML = '<li class="no-results">Type at least 2 characters to search...</li>';
      }
      return;
    }
    const filtered = this.fullArtists.filter((artist) =>
      artist.name.toLowerCase().includes(query)
    );
    this.renderSearchResults(filtered);
  }
  renderSearchResults(artists) {
    if (!this.searchResults) return;
    if (artists.length === 0) {
      this.searchResults.innerHTML = '<li class="no-results">No artists found</li>';
      return;
    }
    const content = artists.slice(0, 40).map((artist) => {
      let target = '';
      if (artist?.url?.includes('http')) {
        target = 'target="_blank"';
      }
      return `<li><a href="${artist.url}" ${target}>${artist.name}</a></li>`;
    });
    if (artists.length > 40) {
      content.push('<li class="no-results">...and more. Refine your search.</li>');
    }
    this.searchResults.innerHTML = content.join('');
  }
  hideSearchDropdown() {
    this.searchOpen = false;
    if (this.searchDropdown) {
      this.searchDropdown.setAttribute('aria-expanded', 'false');
    }
  }
  onLetterMouseOver(e) {
    // Hide search dropdown if open
    if (this.searchOpen) {
      this.hideSearchDropdown();
    }
    const letter = e.target.href.split('#letter-').pop();
    this.showLetter(letter);
  }
  showArtistsList() {
    this.artistsList.setAttribute('aria-expanded', 'true');
  }
  hideArtistsList(e) {
    if (this.artistsList) {
      this.artistsList.setAttribute('aria-expanded', 'false');
    }
    // Also hide search dropdown when leaving
    if (this.searchOpen) {
      this.hideSearchDropdown();
    }
  }
  showLetter(letter) {
    const letters = 'abcdefghijklmnopqrstuvwxyz'.split('');
    const filteredArtistsByLetter = this.artists.filter((artist) => {
      if (letter === 'other') {
        return !letters.includes(artist.name[0].toLowerCase());
      } else {
        return artist.name[0].toLowerCase() === letter;
      }
    });
    const list = document.createElement('ul');
    list.className = 'page-width';
    const content = [];
    content.push(
      `<li class="artists-list__mobile"><button type="button"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path></svg> <span>Browse by artists</span></button></li>`
    );
    // The dropdown is a fixed 300px x 4-column box with overflow:hidden, so
    // anything past 31 artists is clipped silently - including the "view all"
    // link. 23 left the box a third empty; 31 is what actually fits.
    filteredArtistsByLetter.slice(0, 31).map((artist) => {
      let target = '';
      if (artist.url?.includes('http')) {
        target = 'target="_blank"';
      }
      content.push(`<li><a href="${artist.url}" ${target}>${artist.name}</a></li>`);
    });
    content.push(`<li><a href="/pages/artists/#letter-${letter}">...view all artists</a></li>`);
    list.innerHTML = content.join('');
    if (this.artistsList) {
      this.artistsList.innerHTML = '';
      this.artistsList.appendChild(list);
      this.artistsList.setAttribute('aria-expanded', 'true');
      const button = this.artistsList.querySelector('button');
      if (button) {
        button.addEventListener('click', this.hideArtistsList);
      }
    }
  }
  onLetterClick(e) {
    if (window.location.href.includes('/pages/artists')) {
      const hash = e.target.href.split('#').pop();
      const element = document.querySelector(`#${hash}`);
      if (element) {
        window.history.pushState(null, null, e.target.href);
        window.scrollTo({
          top: window.scrollY + element.getBoundingClientRect().top - 160,
          left: 0,
          behavior: 'smooth',
        });
      }
      e.preventDefault();
      return false;
    }
  }
}
if (!customElements.get('artists-list')) {
  customElements.define('artists-list', ArtistsList);
}
